// The user-facing AI chat settings vocabulary — the fixed option sets both
// runtimes must agree on. Shared as plain `as const` arrays so each side applies
// its own boundary treatment: apps/app derives TS unions (`typeof X[number]`)
// and renders the settings picker; apps/vercel-backend builds `z.enum(X)` in its
// request-validation schema. No zod here — the SPA has no zod dependency.

export const AI_CHAT_SETTINGS_MODELS = [
  'default',
  'gpt-5.4-nano',
  'gpt-5.4-mini',
  'gpt-5.4',
  'gpt-5.5',
  'gpt-5.6-luna',
  'gpt-5.6-terra',
  'gpt-5.6-sol',
  'gpt-5.3-codex',
  'gemini-3.1-pro',
  'gemini-3-flash',
  'claude-sonnet-5',
  'claude-opus-4-8',
] as const;

export const AI_CHAT_SETTINGS_PERSONAS = [
  'default',
  'advisor',
  'guide',
  'collaborator',
  'eager_assistant',
] as const;

export const AI_CHAT_SETTINGS_VERBOSITY = ['default', 'low', 'medium', 'high'] as const;

export const AI_CHAT_SETTINGS_REASONING_EFFORT = [
  'default',
  'off',
  'low',
  'medium',
  'high',
] as const;

export const AI_CHAT_SETTINGS_WEB_SEARCH = ['default', 'off', 'on'] as const;

export const AI_CHAT_SETTINGS_REASONING_SUMMARY = [
  'default',
  'off',
  'auto',
  'concise',
  'detailed',
] as const;

export type AiChatSettingsModel = (typeof AI_CHAT_SETTINGS_MODELS)[number];
export type AiChatSettingsPersona = (typeof AI_CHAT_SETTINGS_PERSONAS)[number];
export type AiChatSettingsVerbosity = (typeof AI_CHAT_SETTINGS_VERBOSITY)[number];
export type AiChatSettingsReasoningEffort = (typeof AI_CHAT_SETTINGS_REASONING_EFFORT)[number];
export type AiChatSettingsWebSearch = (typeof AI_CHAT_SETTINGS_WEB_SEARCH)[number];
export type AiChatSettingsReasoningSummary = (typeof AI_CHAT_SETTINGS_REASONING_SUMMARY)[number];

export interface AiChatSettings {
  model?: AiChatSettingsModel;
  persona?: AiChatSettingsPersona;
  verbosity?: AiChatSettingsVerbosity;
  reasoningEffort?: AiChatSettingsReasoningEffort;
  webSearch?: AiChatSettingsWebSearch;
  reasoningSummary?: AiChatSettingsReasoningSummary;
}
